import { render, staticRenderFns } from "./AdsSources.vue?vue&type=template&id=2fb98a92&scoped=true"
import script from "./AdsSources.vue?vue&type=script&lang=js"
export * from "./AdsSources.vue?vue&type=script&lang=js"
import style0 from "./AdsSources.vue?vue&type=style&index=0&id=2fb98a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb98a92",
  null
  
)

export default component.exports